/* rillhouse — product page interactions (gallery, variants, bundles, cart, delivery date, tabs, sticky bar) */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function initGallery(root) {
    var main = root.querySelector('[data-rh-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-rh-thumb]'));
    if (!main || !thumbs.length) return;
    var index = 0;
    function show(i) {
      index = (i + thumbs.length) % thumbs.length;
      var t = thumbs[index];
      main.src = t.getAttribute('data-src');
      main.srcset = t.getAttribute('data-srcset') || '';
      main.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function (el, n) { el.setAttribute('aria-current', n === index ? 'true' : 'false'); });
      t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = root.querySelector('[data-rh-prev]');
    var next = root.querySelector('[data-rh-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    var startX = null;
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
      startX = null;
    });
  }

  function initBuyBox(root) {
    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-rh-bundle]'));
    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-rh-atc]'));
    var error = root.querySelector('[data-rh-error]');
    var state = { qty: 1 };
    function select(card, focus) {
      bundles.forEach(function (b) { var on = b === card; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
      state.qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
      var price = card.getAttribute('data-price');
      var label = card.getAttribute('data-label');
      document.querySelectorAll('[data-rh-price]').forEach(function (el) { el.textContent = price; });
      document.querySelectorAll('[data-rh-bundle-label]').forEach(function (el) { el.textContent = label; });
      if (focus) card.focus();
    }
    bundles.forEach(function (card, i) {
      card.addEventListener('click', function () { select(card, false); });
      card.addEventListener('keydown', function (e) {
        var dir = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
        if (!dir) return;
        e.preventDefault();
        select(bundles[(i + dir + bundles.length) % bundles.length], true);
      });
      if (card.getAttribute('aria-checked') === 'true') select(card, false);
    });
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variant = btn.getAttribute('data-variant');
        if (!variant) return;
        var original = btn.innerHTML;
        buttons.forEach(function (b) { b.disabled = true; });
        btn.textContent = 'Adding…';
        if (error) error.hidden = true;
        var updates = {};
        updates[variant] = state.qty;
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (res) { if (!res.ok) throw new Error('cart'); window.location.href = btn.getAttribute('data-redirect') || '/cart'; })
          .catch(function () { buttons.forEach(function (b) { b.disabled = false; }); btn.innerHTML = original; if (error) error.hidden = false; });
      });
    });
  }

  function initVariants(root) {
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-rh-variant]'));
    if (!opts.length) return;
    var nameEl = root.querySelector('[data-rh-variant-name]');
    var main = document.querySelector('[data-rh-main]');
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        opts.forEach(function (x) { x.setAttribute('aria-checked', x === o ? 'true' : 'false'); });
        var id = o.getAttribute('data-rh-variant');
        document.querySelectorAll('[data-rh-atc]').forEach(function (b) { b.setAttribute('data-variant', id); });
        if (nameEl) nameEl.textContent = o.getAttribute('data-name');
        var src = o.getAttribute('data-src');
        if (src && main) { main.src = src; main.srcset = ''; }
      });
    });
  }

  function initDelivery() {
    var els = document.querySelectorAll('[data-rh-delivery]');
    if (!els.length) return;
    var days = parseInt(els[0].getAttribute('data-days'), 10) || 12;
    var d = new Date();
    d.setDate(d.getDate() + days);
    var text = d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
    Array.prototype.forEach.call(els, function (el) { el.textContent = text; });
  }

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-rh-panel]'));
    function activate(i, focus) {
      tabs.forEach(function (t, n) { var on = n === i; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
      panels.forEach(function (p) { p.hidden = parseInt(p.getAttribute('data-rh-panel'), 10) !== i; });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i, false); });
      t.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        activate((i + dir + tabs.length) % tabs.length, true);
      });
    });
  }

  function setupSticky() {
    var bar = document.querySelector('[data-rh-sticky]');
    if (!bar) return null;
    var btn = bar.querySelector('[data-rh-atc]');
    var info = bar.querySelector('.rh-sticky__info');
    var title = document.querySelector('.rh-buy__title');
    var mainImg = document.querySelector('[data-rh-main]');
    if (info && !info.querySelector('.rh-sticky__name')) {
      if (mainImg) {
        var thumb = document.createElement('img');
        thumb.className = 'rh-sticky__thumb';
        thumb.src = mainImg.currentSrc || mainImg.src;
        thumb.alt = '';
        bar.insertBefore(thumb, info);
      }
      if (title) {
        var name = document.createElement('span');
        name.className = 'rh-sticky__name';
        name.textContent = title.textContent;
        info.insertBefore(name, info.firstChild);
      }
    }
    if (btn && !btn.querySelector('[data-rh-price]')) {
      var label = btn.textContent.trim();
      btn.innerHTML = '';
      var l = document.createElement('span'); l.textContent = label;
      var sep = document.createElement('span'); sep.className = 'rh-btn__sep'; sep.setAttribute('aria-hidden', 'true'); sep.textContent = '|';
      var pr = document.createElement('span'); pr.setAttribute('data-rh-price', '');
      var current = document.querySelector('.rh-bundle[aria-checked="true"]');
      pr.textContent = current ? current.getAttribute('data-price') : '';
      btn.appendChild(l); btn.appendChild(sep); btn.appendChild(pr);
    }
    return bar;
  }

  function initSticky(bar) {
    if (!bar || !('IntersectionObserver' in window)) return;
    var ctas = Array.prototype.slice.call(document.querySelectorAll('[data-rh-atc-main], .rh .rh-btn[href="#top"], .rh-bundles'));
    if (!ctas.length) return;
    var visible = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
      var show = visible.size === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var b = bar.querySelector('[data-rh-atc]');
      if (b) b.tabIndex = show ? 0 : -1;
    }, { threshold: 0.15 });
    ctas.forEach(function (el) { io.observe(el); });
  }

  ready(function () {
    var bar = setupSticky();
    document.querySelectorAll('[data-rh-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-rh-buybox]').forEach(initBuyBox);
    document.querySelectorAll('[data-rh-buybox]').forEach(initVariants);
    document.querySelectorAll('[data-rh-tabs]').forEach(initTabs);
    initDelivery();
    initSticky(bar);
  });
})();
